import React from 'react';
import PropTypes from 'prop-types';
import CustomPortal from '../../commonComponents/CustomPortal';
import { formatDollars } from '../../../domain/Promotions';
import { PAYOUT_REASON_LABELS } from './payoutCsv';
import { COLORS, thStyle, tdStyle } from './constants';
import { pluralPayouts } from './utils';
import { Colors } from '../../../themes/colors';

const formatAmount = (row) =>
  typeof row.amountCents === 'number'
    ? `$${formatDollars(row.amountCents)}`
    : row.amount || '—';

export const PayoutReviewStep = ({ review, onSubmit, onBack, isSubmitting }) => {
  const { valid, invalid, rows } = review;

  return (
    <CustomPortal
      title="Review Payout List"
      cancelText="Back"
      submitText={`Submit ${pluralPayouts(valid.length)}`}
      cancelPressed={onBack}
      submitPressed={onSubmit}
      rightButtonDisabled={valid.length === 0 || isSubmitting}
      containerStyle={{ maxWidth: 720, width: '90vw' }}
    >
      <div style={{ width: '100%' }}>
        <p style={{ textAlign: 'center', color: COLORS.text, marginBottom: 16 }}>
          {valid.length} row{valid.length === 1 ? '' : 's'} ready to submit
          {invalid.length > 0
            ? `, ${invalid.length} excluded (fix and re-upload to include them).`
            : '.'}
        </p>
        <div style={{ maxHeight: 340, overflowY: 'auto', border: `1px solid ${COLORS.border}` }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: COLORS.headerBg }}>
                <th style={{ ...thStyle, width: 60 }}>Line</th>
                <th style={thStyle}>Professional ID</th>
                <th style={thStyle}>Amount</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={`${row.line}-${row.professionalId}`}
                  style={{ borderTop: `1px solid ${COLORS.border}` }}
                >
                  <td style={tdStyle}>{row.line}</td>
                  <td style={tdStyle}>{row.professionalId || '—'}</td>
                  <td style={tdStyle}>{formatAmount(row)}</td>
                  <td style={tdStyle}>
                    {row.valid ? (
                      <span style={{ color: Colors.success_600 }}>Ready</span>
                    ) : (
                      <span style={{ color: Colors.error_500 }} role="alert">
                        {PAYOUT_REASON_LABELS[row.reason] || 'Invalid'}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </CustomPortal>
  );
};

const rowShape = PropTypes.shape({
  line: PropTypes.number,
  professionalId: PropTypes.string,
  amount: PropTypes.string,
  amountCents: PropTypes.number,
  valid: PropTypes.bool,
  reason: PropTypes.string,
});

PayoutReviewStep.propTypes = {
  review: PropTypes.shape({
    valid: PropTypes.arrayOf(rowShape),
    invalid: PropTypes.arrayOf(rowShape),
    rows: PropTypes.arrayOf(rowShape),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};
